import { AlertMessage } from './alert-message.class';

export class AlertInfo extends AlertMessage {
  readonly icon: string = 'circle-info';
  readonly type: string = 'info';

  constructor(code: string, title: string, message: string) {
    super(code, title, message);
  }
}
